import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useHttp } from '../hooks/http.hook'
import { AuthContext } from '../context/AuthContext'
import { LanguagesContext } from "../context/LanguagesContext";

import { Loader } from './components/Loader'
import { Toaster } from './components/Toaster'
//import { Link } from 'react-router-dom'

import './css/ContentPages.css';
import { NewFormBlock } from './components/NewFormBlock';
import { LessonCard } from './lessons/LessonCard';

export const LessonsPage = () => {
    const { token, role } = useContext(AuthContext)
    const { pageLanguage, activeLanguage, getCurrentLanguage } = useContext(LanguagesContext);
    const { request, loading, error, progress, abortUpload } = useHttp()
    const [receivedError, setReceivedError] = useState(error)

    const [lessons, setLessons] = useState([])
    const [dropdownExperiences, setDropdownExperiences] = useState([])

    // LESSONS

    const fetchLessons = useCallback(async () => {
        try {
            const fetched = await request('/lesson/all?filterBy=language', 'GET', null, {
                'x-access-token': token
            })
            if (fetched.lessons) {
                console.log('lessons:', fetched.lessons);
                setLessons(fetched.lessons)
            }

        } catch (e) {
            setReceivedError(e)
        }
    }, [token, request])

    const addLesson = async (formLesson) => {
        //console.log('form to add lesson', formLesson);
        try {
            const data = await request('/lesson/add', 'POST', formLesson, {
                'x-access-token': token
            })

            if (data.lesson) {
                data.lesson.experiences = [];
                setLessons(lessons => [...lessons, data.lesson])
            }
        } catch (e) {
            setReceivedError(e)
        }
    }

    const deleteLesson = async (lessonId) => {
        try {
            const data = await request(`/lesson/${lessonId}/remove`, 'POST', null, {
                'x-access-token': token
            })

            if (data.changed === 1) {
                setLessons(
                    lessons => lessons
                        .filter(item => item.id !== lessonId)
                        .sort((a, b) => a.index - b.index)
                        .map((item, index) => ({
                            ...item,
                            index,
                        }))
                );
            }
        } catch (e) {
            setReceivedError(e)
        }
    }

    const saveLessonNameChanges = async (lessonForm) => {
        console.log('form to update lesson name', lessonForm);

        let lesson = lessonForm[0];

        try {
            const data = await request(`/lesson/${lesson.id}/update`, 'POST', lesson, {
                'x-access-token': token
            })


            if (data.changed === 1) {

                console.log('name should be changed');
                setLessons(
                    lessons => lessons.map(
                        item => {

                            if (item.id === lesson.id) {
                                activeLanguage.map((lang_item, index) =>
                                    item['name_' + lang_item.code] = lesson['name_' + lang_item.code]
                                )
                            }
                            return item
                        }
                    )
                )
            }
            //setLessonUpdateForm(lesson => lesson.filter(item => item.id !== lesson_id))
        } catch (e) {
            setReceivedError(e)
        }
    }

    const changeLessonIndex = async (upperId, lowerId) => {
        try {
            const data = await request(`/lesson/index_change/${upperId}/${lowerId}`, 'POST', { type: 'lesson' }, {
                'x-access-token': token
            })
            
            if (data.upper_changed === 1 && data.lower_changed === 1) {
                //if request success change name
                console.log('name should be changed');

                setLessons(
                    lessons => lessons.map(
                        item => {
                            if (item.id === upperId) {
                                return {
                                    ...item,
                                    index: item.index - 1,
                                }
                            }

                            if (item.id === lowerId) {
                                return {
                                    ...item,
                                    index: item.index + 1,
                                }
                            }

                            return item
                        }
                    )
                )
            }

        } catch (e) {
            setReceivedError(e)
        }
    }

    // EXPERIENCES

    const fetchExperiences = useCallback(async () => {
        try {
            const data = await request(`/experience/all`, 'GET', null, {  // /lite request option
                'x-access-token': token
            })

            setDropdownExperiences(data.experiences)
            //console.log('experiences:', dropdownExperiences);

        } catch (e) {
            setReceivedError(e)
        }
    }, [token, request])


    const addExperienceToLesson = async (lessonId, experience) => {

        if (!experience)
            return;

        try {

            let contentData = await request(`/lesson/${lessonId}/add/${experience.id}`, 'GET', null, {
                'x-access-token': token
            })

            experience.linkId = contentData.id;
            experience.index = contentData.index;

            setLessons(
                lessons => lessons.map(
                    item => {
                        if (item.id === lessonId)
                            item.experiences = [...item.experiences, experience]
                        return item;
                    }
                )
            )
        } catch (e) {
            console.log(e);
            setReceivedError(e)
        }
    }


    // COMMON

    const deleteExperience = async (lessonId, experience) => {

        try {
            const data = await request(`/lesson/${lessonId}/remove/${experience.linkId}`, 'GET', null, {
                'x-access-token': token
            })
            // 
            if (data.changed > 0) {

                setLessons(
                    lessons => lessons.map(
                        lesson => {
                            lesson.experiences = lesson.experiences.filter(e => e.linkId !== experience.linkId);
                            return lesson;
                        }
                    )
                )
            }
        } catch (e) {
            setReceivedError(e)
        }
    }

    const changeExperienceIndex = async (upperId, lowerId) => {
        try {
            const data = await request(`/lesson/index_change/${upperId}/${lowerId}`, 'POST', { type: 'lesson_experience' }, {
                'x-access-token': token
            })
            
            if (data.upper_changed === 1 && data.lower_changed === 1) {
                //if request success change name
                setLessons(
                    lessons => lessons.map(item => ({
                        ...item,
                        experiences: item.experiences.map(experience_item => {
                            if (experience_item.linkId === upperId) {
                                experience_item.index = experience_item.index - 1
                            }

                            if (experience_item.linkId === lowerId) {
                                experience_item.index = experience_item.index + 1
                            }

                            return experience_item;
                        }),
                    }))
                )
            }
        } catch (e) {
            setReceivedError(e)
        }
    }

    // STARTUP

    useEffect(() => {
        fetchLessons()
    }, [fetchLessons])

    useEffect(() => {
        fetchExperiences()
    }, [fetchExperiences])

    // ---------------------
    // RENDER
    // ---------------------        

    return (
        <>
            {(receivedError) ? <Toaster errors_list={receivedError} error_state={setReceivedError} /> : ''}
            {loading && <Loader progress={progress} cancelState={abortUpload} />}

            <h3 className="FormTitle">Lessons List</h3>

            <NewFormBlock languageData={getCurrentLanguage()} addAction={addLesson} loadingState={loading} buttonLabel={'Add Lesson'} placeholderText={"Enter new lesson name on " + getCurrentLanguage().name} />

            {(lessons && lessons.length)
                ?
                <div>
                    {lessons.filter(exp => exp.language === pageLanguage).sort((a, b) => a.index - b.index).map((lesson, index, array) => {
                        const filteredExperiences = dropdownExperiences.filter(exp => !lesson.experiences.some(le => le.id === exp.id));

                        return (
                            <LessonCard
                                key={lesson.id} index={index} lesson={lesson} array={array}
                                pageLanguage={pageLanguage} activeLanguage={activeLanguage}

                                changeLessonIndex={changeLessonIndex}
                                saveLessonNameChanges={saveLessonNameChanges}
                                deleteLesson={deleteLesson}

                                deleteExperience={deleteExperience}
                                changeExperienceIndex={changeExperienceIndex}
                                addExperienceToLesson={addExperienceToLesson}

                                dropdownExperiences={filteredExperiences}
                                editableTable={role === 'admin'}
                                setReceivedError={setReceivedError}
                            />
                        )
                    })
                    }
                </div>
                : <span className="NoElementsText">No Lessons Data</span>}


        </>
    )
}
